import React from "react";
import { blogData, BlogSummaries } from "../../../App";
import { Link, NavLink } from 'react-router-dom'
import './blogdata.css'



const BlogData = (props: any) => {
    const { contents, setCurrentBlogName, navigateToPost, style } = props;
    const moveToPost = (title: string) => {
        setCurrentBlogName(title)
        navigateToPost();
    }
    console.log(contents)
    return (
        <div style={style} className={'blog-summaries'}>
            {contents.map((post: BlogSummaries) => {
                return (
                <div className={'article-hugger'}>
                    <article id={`post-${post.data.id}`} className={'blog-article'}>
                        <div>
                            <NavLink onClick={() => {moveToPost(post.data.title)}} className={'blog-title'} to={`/post?${post.data.id}`}>
                                <h1>{post.data.title}</h1>
                            </NavLink>
                            <p className={'date-p'}><i>{`Updated on ${post.date.slice(0, 10)}`}</i></p>
                        </div>
                        <section className={'summary'}>
                            <p dangerouslySetInnerHTML={{__html: post.data.summary}}></p>
                            <div className={'button-div'}>
                                <NavLink onClick={() => {moveToPost(post.data.title)}} className={'reading-button'} to={`/post?${post.data.id}`}>
                                    <span className={'keep-reading'}>KEEP READING
                                        <i id={'forward-symbol'} className={'fa fa-angle-double-right'}></i>
                                    </span>
                                </NavLink>
                            </div>
                            <hr id={'hr'}></hr> 
                        </section>
                    </article>
                    
                </div>
                );                
            })}
        </div>
    )
}
export default BlogData;